import useUserMetadata from '@/user/hooks/useUserMetadata'
import { useToast } from '@chakra-ui/react'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { trpc } from 'src/trpc'
import { downloadBase64File } from '../meetingSummaryShareEvents'

// The circle's compte rendu as a PDF (#131): the whole of it, as the reader may
// read it. Not a share — nothing goes into the sharing history.
export default function useDownloadCircleSummaryPdf() {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const { metadata } = useUserMetadata()
  const toast = useToast()
  const [downloading, setDownloading] = useState<string | undefined>()

  const download = useCallback(
    async (meetingId: string) => {
      setDownloading(meetingId)
      try {
        downloadBase64File(
          await trpc.meeting.exportCircleSummaryPdf.mutate({
            meetingId,
            lang: language,
            timezone:
              metadata?.timezone ||
              Intl.DateTimeFormat().resolvedOptions().timeZone,
          })
        )
      } catch (error) {
        console.error(error)
        toast({
          title: t('common.errorOccurred'),
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      } finally {
        setDownloading(undefined)
      }
    },
    [language, metadata?.timezone, t, toast]
  )

  // `downloading`: the meeting whose PDF is being made, if any
  return { download, downloading }
}
